import { useContext } from 'react';

import { SmxPermissionContext } from '../provider/permission-provider';
import { PermissionCombinationType } from '../types';
import { accessCheck } from './access-check';

export const useAccess = (accessFor: PermissionCombinationType[], isOwner?: boolean, isAssignee?: boolean) => {
    const { permissionListScore } = useContext(SmxPermissionContext);

    return accessCheck(permissionListScore, accessFor, isOwner, isAssignee);
};
